import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import { ResetPasswordData, ChangePasswordBody } from '../types';
import env from '@/env';
import { jsonifyEscape } from '@/core';

export const changePassword = async ({
  password,
  confirmPassword,
  recoverHash,
}: ChangePasswordBody): Promise<ResetPasswordData> => {
  const fetchResponse = await fetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/auth/change-password`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        password,
        confirmPassword,
        recoverHash,
      }),
    }
  );

  if (!fetchResponse.ok) {
    const error = JSON.parse(jsonifyEscape(await fetchResponse.text())) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as ResetPasswordData;
  return response;
};
